// extracted by mini-css-extract-plugin
export default {"outer-box":"Checkbox_outer-box__T1yNy","tick":"Checkbox_tick__Xcbg9"};